/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
import { WeakPasswordFeedback } from './WeakPasswordFeedback';
const WeakPasswordExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['feedback', WeakPasswordFeedback]]), BaseError);
export class WeakPasswordException extends BaseError {
    static decode(input) {
        return WeakPasswordExceptionParser.decode(input).map(res => new WeakPasswordException(res));
    }
    static unsafeDecode(input) {
        return WeakPasswordException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WeakPasswordExceptionParser.encode(data);
    }
    static schema() {
        return WeakPasswordExceptionParser.schema();
    }
}
